import React from "react";


const Footer = () =>{
    return(
    <>
    <div id="footer" className="theme-bg-default">
    <div className="container">
      <div className="row">
        <div className="col-lg-4">
          <div className="footer-item">
            <div className="footer-logo">
              <a className="navbar-brand logo" href="#lu">
                <span className="logo-icon mdi-bg mdi-bg-sm theme-bg-white">
                  P
                </span>
                <span className="logo-text">PerennialLink</span>
              </a>
            </div>
            <div className="footer-about-content">
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s.
              </p>
            </div>
            <ul className="smedia-icons">
              <li>
                <a href="#lu">
                  <i className="mdi mdi-facebook mdi-bg mdi-bg-sm theme-btn-default-two" />
                </a>
              </li>
              <li>
                <a href="#lu">
                  <i className="mdi mdi-twitter mdi-bg mdi-bg-sm theme-btn-default-two" />
                </a>
              </li>
              <li>
                <a href="#lu">
                  <i className="mdi mdi-pinterest mdi-bg mdi-bg-sm theme-btn-default-two" />
                </a>
              </li>
              <li>
                <a href="#lu">
                  <i className="mdi mdi-linkedin mdi-bg mdi-bg-sm theme-btn-default-two" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="footer-item-list">
            <div className="mb-30px">
              <h3 className="head-after head-after-white">Footer Links</h3>
            </div>
            <div className="footer-list">
              <div className="row">
                <div className="col-lg-5">
                  <ul>
                    <li>
                      <a
                        className="btn-icon btn-icon-active"
                        href="#lu"
                      >
                        <span>Home</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>About Us</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Portfolio</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Team</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Blog</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Contact Us</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-7">
                  <ul>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Event Planning</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Logistics</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Food</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Insurance</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Hiring</span>
                      </a>
                    </li>
                    <li>
                      <a className="btn-icon" href="#lu">
                        <span>Auto Parts</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="footer-item">
            <div className="mb-30px">
              <h3 className="head-after head-after-white">Contact Us</h3>
            </div>
            <div className="footer-contact">
              <div className="footer-contact-info-div">
                <h6>
                  <i className="mdi mdi-map-marker mdi-bg mdi-bg-sm-sm theme-bg-dark" />{" "}
                  Address
                </h6>
                <p>Tema C11.</p>
              </div>
              <div className="footer-contact-info-div">
                <h6>
                  <i className="mdi mdi-phone mdi-bg mdi-bg-sm-sm theme-bg-dark" />{" "}
                  Phone
                </h6>
                <p>+233 (54) 589 8775</p>
              </div>
              <div className="footer-contact-info-div">
                <h6>
                  <i className="mdi mdi-email-open mdi-bg mdi-bg-sm-sm theme-bg-dark" />{" "}
                  Email
                </h6>
                <p>info@perenniallink.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* END FOOTER */}
  {/* START SUB FOOTER */}
  <div id="sub-footer" className="theme-bg-dark">
    <div className="col-lg-12">
      <div className="text-center">
        <a
          className="mdi mdi-bg mdi-bg-sm theme-btn-default backto-top-btn easing-click"
          href="#body-top"
        >
          <i className="mdi mdi-chevron-double-up" />
        </a>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="sub-footer-left">
            <ul>
              <li>
                <a href="#lu">Support</a>
              </li>
              <li>
                <a href="#lu">Chat</a>
              </li>
              <li>
                <a href="#lu">Privacy Policy</a>
              </li>
              <li>
                <a href="#lu">Terms and Conditions</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="sub-footer-right">
            <p>
              © 2023 <a href="#lu">Perennial Link</a> All Right Reserved.
            </p>
            <p>
              Designed by <a href="#lu">Sen Gideons</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
    )
}

export default Footer